<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/epFS1H/tc-custom/9781429909945.jpg?1731411132610" alt="This image is the cover for the book First Blue"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">First Blue
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Robert K Wilcox's <i>First Blue </i>presents the remarkable story of a true hero of American aviation during World War II.<br/></b><br/>The U.S. Navy's Blue Angels are the most famous flight demonstration team in the world. While millions of aviation enthusiasts see their shows every year, the story of the man who formed the squadron has never been told. He is Roy Marlin "Butch" Voris, a World War II Ace and one of only two aviators ever to command the Blue Angels twice.<br/><br/><i>First Blue</i> details the epic journey of an unassuming man whose strong character and desire to fly launched him into a life of drama, heroism, and accomplishment unique in his field. Because he wanted to serve his country during World War II, a young Butch Voris found himself flying fighter planes as part of the pitifully prepared and outmanned front in the early stages of the Pacific theater. He was nearly killed there but went on to be a leader in one of the most fearsome naval air squadrons in the Pacific. As a pilot, Butch is unquestionably in the same class as more recognized aviator heroes such as Chuck Yeager and Pappy Boyington.<br/><br/>While his World War II experience alone could comprise a book, Butch may be best known for his efforts in the creation of the naval air demonstration team, the Blue Angels. After the war, Voris was personally chosen by Admiral Nimitz to start the Blue Angels and to lead them, first in prop planes and later in jets. The story of his efforts is as exciting as it is inspirational, and it's told here in meticulous detail and with great humor. Today the Blue Angels still follow traditions established by Butch.<br/><br/>Butch's involvement in military flight didn't end with the Blue Angels; he became a major player in the development of the F-14 Tomcat and NASA's Lunar Explorer Module for Grumman. Butch dedicated his life to his work, and here, finally, is the remarkable, untold account of this true American aviation pioneer and hero: a man whose life had unparalleled influence on naval aviation and whose legacy continues to inspire millions of Americans each year.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Robert K. Wilcox, James Lovell
      </h2>
      
      <p class="authorDescription body article"><P><B>Robert Wilcox</B> is a former air force information officer and the author of <I>Wings of Fury</I>, <I>Scream of Eagles</I>, and other books. He  lives in Los Angeles with his wife where he also writes television and movie scripts.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?292af642